import React from 'react'
import RadioDualComponent from '../RadioDualComponent'
import ico from 'images/products/wave_solder_pallets/top-hat.png'

const NeedTopHat = (props) => {
  const name = 'pallet_need_top_hat';
  const onChange = e => props.onChangeParameter(name, e.target.value);
  return (
    <div className="row g-0 mb-3">
      <div className="col-4 col-md-3 col-lg-4">
        <img src={ico} alt="Need a Top Hat" className="img-fluid mb-3" />
      </div>
      <div className="col-8 col-md-9 col-lg-8 ps-3 ps-md-0 ps-lg-3">
      <RadioDualComponent
        label="Does your pallet need a top hat?"
        name={name}
        inputId={props.inputId}
        onChange={onChange}
        tooltip={props.tooltip}
        parameters={props.parameters}
        className={props.className}
        required={props.required}>
        {props.children}
      </RadioDualComponent>
      </div>
    </div>
  );
}

NeedTopHat.defaultProps = {
  inputId: 'pallet_need_top_hat',
  required: true,
}
export default NeedTopHat;
